(function(){
  function byId(id){ return document.getElementById(id); }

  function reveal(){
    var targets = document.querySelectorAll('.spin-service-card, .spin-web-card, .spin-industry-card, .spin-process-card, .spin-book-card, .spin-performance-card, .spin-screen, .spin-quote-wrap, .spin-capability-card, .spin-journey-step, .spin-deliverable-card, .spin-map-column, .spin-revenue-shell, .spin-flow-card, .spin-revenue-node, .spin-clean-chart-card, .spin-clean-outcome, .spin-partner-card');
    if(!('IntersectionObserver' in window)){
      targets.forEach(function(el){ el.classList.add('spin-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('spin-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: .12 });
    targets.forEach(function(el){ io.observe(el); });
  }

  function recommendation(){
    var root = document.querySelector('.spin-quote-panel');
    if(!root) return;
    var result = byId('spinRecommendation');
    var hidden = byId('spinQuoteMessage');
    var fields = ['spinIndustry','spinSize','spinSpend','spinChannels','spinWebsite','spinGoal','spinNotes'];
    var inputs = fields.map(byId).filter(Boolean);
    var hasInteracted = false;
    if (result) {
      result.innerHTML = '';
      result.classList.remove('has-recommendation');
    }
    if (hidden) hidden.value = '';
    var plans = {
      traffic: {
        stack: ['Google Ads', 'SEO', 'AEO', 'Content Marketing'],
        path: [
          ['Increase visibility', 'Put the business in front of more relevant people through search, content and paid discovery.'],
          ['Strengthen landing experience', 'Make the traffic land on a page that explains the offer clearly and keeps users moving.'],
          ['Build long term momentum', 'Turn short term traffic gains into sustainable search presence and brand authority.']
        ],
        focus: ['Traffic quality', 'Search visibility', 'Content authority']
      },
      leads: {
        stack: ['Lead Generation', 'Landing Page Design', 'Google Ads', 'CRM Ready Forms'],
        path: [
          ['Refine the offer', 'Clarify the service message, trust points and call to action so the enquiry route feels obvious.'],
          ['Send better traffic', 'Use high intent campaign structure and targeting to attract people more likely to enquire.'],
          ['Improve conversion', 'Reduce friction in forms, landing pages and follow up so more interest becomes a lead.']
        ],
        focus: ['Lead quality', 'Enquiry conversion', 'Sales readiness']
      },
      sales: {
        stack: ['E Commerce Growth', 'Social Media Ads', 'Email Marketing', 'CRO'],
        path: [
          ['Increase buying intent', 'Bring in more relevant traffic through paid channels and stronger product positioning.'],
          ['Raise store conversion', 'Improve product pages, trust, checkout flow and user experience so more users purchase.'],
          ['Grow customer value', 'Use retention and follow up systems to encourage repeat custom and stronger average order value.']
        ],
        focus: ['Online sales', 'Conversion rate', 'Customer value']
      },
      website: {
        stack: ['Bespoke Website Design', 'CRO', 'Brand Identity', 'Animated Website Design'],
        path: [
          ['Redesign the experience', 'Create a stronger first impression with clearer structure, messaging and modern visuals.'],
          ['Guide the journey', 'Build content sections and page paths that naturally lead users toward an enquiry or purchase.'],
          ['Support growth', 'Make the site easier to market, easier to trust and easier to convert from.']
        ],
        focus: ['Website quality', 'Brand perception', 'User journey']
      },
      brand: {
        stack: ['Content Creation', 'Organic Social', 'Brand Identity', 'Social Media Management'],
        path: [
          ['Strengthen the brand image', 'Improve how the business looks and sounds across social, website and campaign assets.'],
          ['Build a clearer message', 'Create content that makes the offer easier to understand and more appealing.'],
          ['Grow familiarity', 'Use consistent activity and stronger creative to increase recognition and trust.']
        ],
        focus: ['Brand presence', 'Creative clarity', 'Audience trust']
      },
      automation: {
        stack: ['AI Services', 'Email Automation', 'Lead Qualification', 'Reporting Systems'],
        path: [
          ['Reduce manual friction', 'Use automation and AI to support repetitive marketing and follow up tasks.'],
          ['Improve response speed', 'Make it easier for leads and customers to get the next step without delay.'],
          ['Create a smarter system', 'Use automation to support growth while keeping the customer journey organised.']
        ],
        focus: ['Efficiency', 'Follow up', 'Systemisation']
      }
    };
    function build(){
      if (!hasInteracted) return;
      var industry = byId('spinIndustry')?.value || 'your industry';
      var size = byId('spinSize')?.value || 'your business';
      var spend = byId('spinSpend')?.value || 'your current budget';
      var channels = byId('spinChannels')?.value || 'your current channels';
      var website = byId('spinWebsite')?.value || 'your website setup';
      var goal = byId('spinGoal')?.value || 'leads';
      var plan = plans[goal] || plans.leads;
      var chips = plan.stack.map(function(item){ return '<span class="spin-rec-chip">' + item + '</span>'; }).join('');
      var focus = plan.focus.map(function(item){ return '<div class="spin-rec-focus-card"><strong>' + item + '</strong><small>Priority area for the next stage of growth.</small></div>'; }).join('');
      var stages = plan.path.map(function(step, index){
        return '<div class="spin-rec-stage"><div class="spin-rec-stage-no">0' + (index + 1) + '</div><div class="spin-rec-stage-copy"><strong>' + step[0] + '</strong><small>' + step[1] + '</small></div></div>';
      }).join('');
      var html = '';
      html += '<div class="spin-rec-visual">';
      html += '<div class="spin-rec-hero"><span class="spin-card-eyebrow">Suggested Growth Path</span><strong>For ' + industry + ', Spin Digital would likely focus on a clearer ' + goal.replace('-', ' ') + ' journey.</strong><p>This visual recommendation is shaped around your main goal, business stage and current digital position.</p></div>';
      html += '<div class="spin-rec-focus">' + focus + '</div>';
      html += '<div class="spin-rec-service-stack"><span class="spin-card-eyebrow">Recommended Services</span><div class="spin-rec-chip-row">' + chips + '</div></div>';
      html += '<div class="spin-rec-path"><span class="spin-card-eyebrow">Transformation Path</span>' + stages + '</div>';
      html += '<div class="spin-rec-summary"><div class="spin-rec-card"><strong>Current Position</strong>' + size + ' business, ' + spend + ' budget range, using ' + channels + ' with a website status of ' + website + '.</div><div class="spin-rec-card"><strong>Next Step</strong>Submit the form and Spin Digital can turn this path into a tailored quote with the right services, priorities and rollout plan.</div></div>';
      html += '</div>';
      result.innerHTML = html;
      result.classList.add('has-recommendation');
      if(hidden){
        hidden.value = 'Industry: ' + industry + '\n' +
          'Business size: ' + size + '\n' +
          'Ad spend: ' + spend + '\n' +
          'Channels used: ' + channels + '\n' +
          'Website status: ' + website + '\n' +
          'Main goal: ' + goal + '\n' +
          'Recommended services: ' + plan.stack.join(', ');
      }
    }
    inputs.forEach(function(input){
      input.addEventListener('change', function(){ hasInteracted = true; build(); });
      input.addEventListener('input', function(){ hasInteracted = true; build(); });
    });
  }

  function navFix(){
    document.querySelectorAll('a').forEach(function(a){
      var label = (a.textContent || '').trim().toLowerCase();
      if(label === 'home') a.setAttribute('href', '/');
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    reveal();
    recommendation();
    navFix();
  });
})();
